import React from 'react';
import styles from './TabBar.module.css';

interface Tab {
  id: string;
  label: string;
  count?: number;
  badgeCount?: number;
}

interface TabBarProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (id: string) => void;
  className?: string;
}

const TabBar: React.FC<TabBarProps> = ({ tabs, activeTab, onTabChange, className = '' }) => {
  return (
    <div className={`${styles.tabs} ${className}`}>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`${styles.tab} ${activeTab === tab.id ? styles.activeTab : ''}`}
          data-testid={`tab-${tab.id}`}
        >
          {tab.label}
          {tab.count !== undefined && <span className={styles.count}>({tab.count})</span>}
          {tab.badgeCount !== undefined && tab.badgeCount > 0 && (
            <span className={styles.badge} data-testid={`tab-badge-${tab.id}`}>
              {tab.badgeCount}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default TabBar;
